module.exports = __webpack_public_path__ + "static/img/rank_352.4404531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_352.png
// module id = iyWi
// module chunks = 1